var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLikeDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.43 7.1152C14.17 6.74187 13.71 6.52853 13.1833 6.52853H10.45C10.27 6.52853 10.1033 6.4552 9.99 6.32187C9.87 6.18853 9.82333 6.00186 9.85 5.80853L10.19 3.62186C10.3367 2.96853 9.90333 2.2352 9.25 2.0152C8.64333 1.78853 7.93 2.0952 7.64333 2.52853L4.83 6.70853L4.75 6.84187V12.7352L4.85 12.8352L6.96333 14.4685C7.24333 14.7485 7.87667 14.9019 8.32333 14.9019H10.9233C11.8167 14.9019 12.7167 14.2285 12.9167 13.4085L14.5567 8.4152C14.73 7.94186 14.6833 7.48186 14.43 7.1152Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.47594 4.68213H2.78927C1.75594 4.68213 1.33594 5.08213 1.33594 6.0688V12.7755C1.33594 13.7621 1.75594 14.1621 2.78927 14.1621H3.47594C4.50927 14.1621 4.92927 13.7621 4.92927 12.7755V6.0688C4.92927 5.08213 4.50927 4.68213 3.47594 4.68213Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeDark);
export default __webpack_public_path__ + "static/media/like_dark.33e6c5be3a8c91a9347569a137087d9d.svg";
export { ForwardRef as ReactComponent };